import {
  SUPPORTED_IMAGE_TYPES,
  SUPPORTED_DOCUMENT_TYPES,
  SUPPORTED_VIDEO_TYPES,
  SUPPORTED_AUDIO_TYPES,
} from '@packages/shared/constants/Assets';
import {getNormalizedExtension} from '@packages/shared/utils/FileUtils';

type RegexMap = {
  [key: string]: RegExp;
};

type IsBlobOfType = (arg1: RegexMap) => (arg1: File) => boolean;
export const isBlobOfType: IsBlobOfType = (supportedTypes) => (blob: File) =>
  Boolean(supportedTypes[getNormalizedExtension(blob.name)]);

export const isImageBlob = isBlobOfType(SUPPORTED_IMAGE_TYPES);
export const isVideoBlob = isBlobOfType(SUPPORTED_VIDEO_TYPES);
export const isDocumentBlob = isBlobOfType(SUPPORTED_DOCUMENT_TYPES);
export const isJsonBlob = isBlobOfType({json: SUPPORTED_DOCUMENT_TYPES.json});
export const isDotLottieBlob = isBlobOfType({
  lottie: SUPPORTED_DOCUMENT_TYPES.lottie,
});
export const isDotRiveBlob = isBlobOfType({
  riv: SUPPORTED_DOCUMENT_TYPES.riv,
});
export const isAudioBlob = isBlobOfType(SUPPORTED_AUDIO_TYPES);
export const isZipBlob = isBlobOfType({zip: SUPPORTED_DOCUMENT_TYPES.zip});
